import { render } from "./PublicGroup.vue?vue&type=template&id=4d319bda"
import script from "./PublicGroup.vue?vue&type=script&lang=js"
export * from "./PublicGroup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__